<script>
    export default {
        name: "ProductNavigation",
        props: {
            product: Object,
            listAnchor: Array,
            selectedTab: {
                type: String,
                default: "description",
            },
        },
        computed: {
            linksList() {
                const links = [];

                if (this.product.text.length > 0) {
                    links.push({
                        name: "Описание",
                        hash: "description",
                    });
                }

                if (this.product.allSpecifications.length > 0) {
                    links.push({
                        name: "Характеристики",
                        hash: "characteristic",
                    });
                }

                this.listAnchor.forEach((item) => {
                    if (item === "reviews") {
                        links.push({
                            name: "Отзывы",
                            hash: "reviews",
                        });
                    }
                });

                return links;
            },
        },
        mounted() {
            if (this.product.text.length === 0) {
                this.$emit("on-change", "characteristic");
            }
        },
        methods: {
            clickHandler(hash) {
                this.$emit("on-change", hash);
            },
        },
    };
</script>

<template>
    <div class="product-navigation">
        <div class="product-navigation__inner">
            <div class="product-navigation__list">
                <div
                    class="product-navigation__item"
                    :class="{
                        active: link.hash === selectedTab,
                        'has-label': link.hash === 'reviews',
                    }"
                    v-for="link in linksList"
                    :key="link.id"
                    @click="clickHandler(link.hash)"
                >
                    {{ link.name }}
                </div>
            </div>
        </div>
    </div>
</template>
